import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { Version } from "../../model/version/version.model";
import { TVersionStatus } from "../../services/version/contract/version.contract";
import { createUrl } from "../api.util";
import { GenericApi } from "../generic.api";

// Convenience Type
type T = Version;

/**
 * @description stores the current build of the angular application, used to ensure users are using the latest version
 */
@Injectable({
  providedIn: "root",
})
export class VersionApi extends GenericApi<T> {
  public path = "version";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  readonly checkVersion = (currentVersion: string): Observable<TVersionStatus> => {
    return this.httpClient.get<TVersionStatus>(
      createUrl(this.path, "check-version", currentVersion),
    );
  };
}
